// extracted by mini-css-extract-plugin
module.exports = {"circle":"Colors-module--circle--2uWNP"};